import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { Helmet } from 'react-helmet';
import Loader from '../components/Loader';

const Reports = () => {
    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeIndex, setActiveIndex] = useState(null);
    const logoImgRefs = useRef([]);
    const coverImgRefs = useRef([]);
    const loadedCount = useRef(0);

    const updateHeights = () => {
        logoImgRefs.current.forEach((logo, index) => {
            const cover = coverImgRefs.current[index];
            if (logo && cover) {
                const height = logo.offsetHeight;
                cover.style.height = `${height}px`;
                console.log(height);
            }
        });
    };

    useEffect(() => {
        const fetchListings = async () => {
            const hostData = getItemFromLocalStorage('hostProfile');
            let formData = new FormData();
            formData.append('token', hostData.host_access_token);

            try {
                const response = await axios({
                    method: 'post',
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    url: `${params.baseURL}${params.endpoints.getMyCalendar}`,
                    data: formData
                });

                if (response.data.items && Array.isArray(response.data.items)) {
                    setListings(response.data.items);
                    setLoading(false);
                } else {
                    setError('An error occurred while fetching data.');
                }
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };

        fetchListings();
    }, []);

    const handleImageLoad = (index) => {
        loadedCount.current += 1;
        if (loadedCount.current === listings.length * 2) {
            updateHeights();
        }
    };

    useEffect(() => {
        if (listings.length > 0) {
            window.addEventListener('resize', updateHeights);
            return () => {
                window.removeEventListener('resize', updateHeights);
            };
        }
    }, [listings]);

    const faqs = [
        {
            question: "What is Lorem Ipsum?",
            answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
        },
        {
            question: "Where does it come from?",
            answer: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
        },
    ];
    
    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return <p>Error loading listings: {error.message}</p>;
    }

    return (
        <div>
            <Helmet>
                <title>Property Reports</title>
                <meta name="description" content="" />
            </Helmet>

            <div className='row'>
                <div className='col-md-8'>
                    <div className='yl-header'>
                        <div className='img-title-box'>
                            <img src={'/assets/img/title/accelerate_title.svg'} className='img-fluid img-title' alt='' />
                        </div>
                    </div>

                    {listings.length > 0 ? (
                    <div className='row'>
                        {listings.map((listing, index) => (
                            <div className='col-md-6 lb' key={listing.stay_listing_id}>
                                <a href={`/listing-reports/${listing.stay_listing_id}`}>
                                    <div className='acc-box' style={{ marginBottom: '10px' }}>
                                        <div className="apimgcibox">
                                            <div className='image-wrapper lcibox'>
                                                <div className='ac-cover-image'>
                                                    <img
                                                        ref={(el) => (coverImgRefs.current[index] = el)}
                                                        className="ciso ap-ciso"
                                                        src={listing.cover_photo ? listing.cover_photo : '/assets/img/default_listing.jpg'}
                                                        alt={listing.listing_title ? listing.listing_title : 'Untitled Listing'}
                                                        onLoad={() => handleImageLoad(index)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="logo-wrapper">
                                                <img
                                                    ref={(el) => (logoImgRefs.current[index] = el)}
                                                    src={listing.category_info.category_image_url}
                                                    alt=''
                                                    className='cist'
                                                    onLoad={() => handleImageLoad(index)}
                                                />
                                            </div>
                                        </div>
                                        <div className='pltxt-box'>
                                            <div className='cat-pointer mb-0'>
                                                <img src={'/assets/img/icons/pointer_icon.svg'} alt="Profile" className="pointer-icon" />
                                                <span>
                                                {
                                                    (() => {
                                                    const title = listing.listing_title?.trim();
                                                    const address = listing.property_address?.trim();
                                                    const text = title || address || 'Unknown Title';

                                                    const words = text.split(/\s+/);
                                                    return words.length > 3
                                                        ? words.slice(0, 3).join(' ') + '...'
                                                        : text;
                                                    })()
                                                }
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='co-host-box'>
                                        <span className='acc-btn-txt'>View Reports</span>
                                    </div>
                                </a>
                            </div>
                        ))}
                    </div>
                    ) : (
                        <p>No active listings found</p>
                    )}
                </div>
                <div className='col-md-4 p-0'>
                    <div className='bfhsd'>
                        <div className='blog-box'>
                            <div class="blog">
                                <div class="blog-image">
                                    <img src={'https://app.wirestay.com/ws/uploads/blog/1736870810_pi.jpg'} className='img-fluid' alt="" />
                                    <div class="date">May 08, 2025</div>
                                </div>
                                <div class="blog-content">
                                    <h2>What is Lorem Ipsum?</h2>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vel metus vel est fermentum consectetur.</p>
                                    <a href="#">Read More</a>
                                </div>
                            </div>
                        </div>
                        <div className="faq-sticky">
                            {faqs.map((faq, index) => (
                            <div key={index} className='faqs-list-section'>
                                <div
                                onClick={() => toggleAccordion(index)} className='faqs-qustn-box'
                                style={{
                                    backgroundColor: activeIndex === index ? "#f7f7f7" : "#ffffff",
                                }}
                                >
                                {faq.question}
                                <i
                                    className={`fas ${
                                    activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"
                                    }`}
                                    style={{
                                    transition: "transform 0.3s ease",
                                    }}
                                ></i>
                                </div>
                                {activeIndex === index && (
                                <div className='faqs-ans-box'>
                                    {faq.answer}
                                </div>
                                )}
                            </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Reports;